<template>
<div>
    <div class="px-5 pb-5 pt-2">
        <div class="row">
            <div class=" btn-home  col-md-12 mt-3 mb-4 d-flex justify-content-end">
                <button type="button" class="btn btn-outline-main" @click="returnHome">
                    <i class="fas fa-home-lg-alt"></i> Inicio
                </button>
            </div>
        </div>
        <div class="d-flex justify-content-center">
            <div class="card w-100 mb-lg-5">
                <!-- <div class="text-center card-header text-white h4 bg-main">
                    <strong>TRAMAS</strong>
                </div> -->
                <div class="card-body w-100">
                    <div class="row d-flex">
                        <!-- Escoger mes -->
                        <div class="col-xl-2 col-lg-3 col-md-4 col-sm-12 col-xs-12">
                            <div class="input-group input-group-sm mt-2 px-3 w-100">
                                <span class="input-group-text col-md-4">Mes</span>
                                <select class="form-control form-control-input form-control-sm" id="finalizo_mes" v-model="filter.mounth" @change="mtdGetData">
                                    <option value="0" disabled>[Seleccione...]</option>
                                    <option v-for="(item, index) in months" :key="index" :value="index + 1">
                                        {{ item }}
                                    </option>
                                </select>
                            </div>
                        </div>
                        <!-- lista de pisos -->
                        <div class="col-xl-8 col-md-8 col-sm-12 col-lg-9 col-xs-12 px-3">
                            <ul class="nav pb-0 mt-2" id="myTab" role="tablist">
                                <li v-for="(item, index) in tables" :key="index" class="nav-item-floor" role="presentation">
                                    <div class="btn-group">
                                        <button @click="changeTable(item.id,index)" :class="{
                          'item-button-tramas': true,
                          'nav-link': true,
                          active: filter.table === item.id,
                        }" id="home-tab" type="button">
                                            {{ item.label }}
                                        </button>
                                    </div>
                                </li>
                            </ul>
                        </div>
                        <div class="col-xl-2 col-lg-12 col-md-12 col-sm-12 col-xs-12">
                            <div class="d-flex justify-content-end mt-2 px-3">
                                <button class="btn btn-sm btn-info text-white " @click="mtdExporTxt()">
                                    <i class="fas fa-file-alt"></i>&nbsp;Exportar txt
                                </button>
                            </div>
                        </div>
                        <!-- Mostrar la tabla -->
                        <div class="col-md-12 mt-2">
                            <div class="row m-2 p-2 d-flex justify-content-center">
                                <div class="col-md-12 px-0" id="content-timelinetable">
                                    <table id="dtb-cxc" class="table table-bordered border-main text-center align-middle">
                                        <caption class="py-0 my-0"></caption>
                                        <thead>
                                            <tr :class="cpClass" style="vertical-align: middle">
                                                <th scope="col">Período de Reporte</th>
                                                <th scope="col">Código de la IPRESS</th>
                                                <th scope="col">Código de la UGIPRESS</th>
                                                <template v-for="(itemth) in tables[pos].thead">
                                                    <th scope="col">{{itemth}}</th>
                                                </template>
                                            </tr>
                                        </thead>
                                        <tbody>
                                            <tr v-for="(item, index) in tables[pos].tbody" :key="index" class="border border-main text-xs">
                                                <td>{{ period }} </td>
                                                <td>{{ ipress }}</td>
                                                <td>{{ ipress }}</td>

                                                <!-- Mapeo dinámico para las columnas de las 13 tablas -->
                                                <template v-for="(field, fieldIndex) in getColumnsByPos(pos, item)">
                                                    <td>{{ field }}</td>
                                                </template>
                                            </tr>
                                        </tbody>
                                    </table>
                                </div>
                            </div>
                        </div>
                    </div>
                </div>
            </div>
        </div>

    </div>
    <SweetAlert :swal="swal" ref="SweetAlert" />
</div>
</template>

<script>
import {
    mapActions
} from "vuex";
import moment from "moment";
import SweetAlert from '@/components/shared/SweetAlert/SweetAlert.vue';
import exportFromJson from "export-from-json";

export default {
    name: "c-admision-pages-anular",
    components: {
        SweetAlert,
    },
    data() {
        return {
            filter: {
                begindate: null,
                enddate: null,
            },
            swal: null,
            search: "",
            pos: 0,
            months: [
                'Enero', 'Febrero', 'Marzo', 'Abril', 'Mayo', 'Junio',
                'Julio', 'Agosto', 'Septiembre', 'Octubre', 'Noviembre', 'Diciembre'
            ],
            tables: [{
                    id: 1,
                    label: 'A',
                    thead: ['Consultorios Fisicos', 'Consultorios Funcionales', 'Camas Hospitalarias', 'Total de Medicos', 'Medicos Serums', 'Medicos Residentes', 'Enfermeras', 'Odontologos', 'Psicologos', 'Nutricionistas', 'Tecnologos medicos', 'Obstetrices', 'Farmaceuticos', 'Auxiliares /Tecnicos', 'Otros profesionales', 'Ambulancias'],
                    tbody: [],
                },
                {
                    id: 2,
                    label: 'B1',
                    thead: ['Sexo del Paciente', 'Grupo de Edad en años', 'Atenciones Medicas', 'Atenciones No Medicas', 'Atendidos/ Mes'],
                    tbody: [],
                },
                {
                    id: 3,
                    label: 'B2',
                    thead: ['Sexo del Paciente', 'Grupo etario', 'Diagnosticos definitivos', 'Total de Atendidos'],
                    tbody: [],
                },
                {
                    id: 4,
                    label: 'C1',
                    thead: ['Sexo', 'Grupo etario', 'Numero Total de Atencion', 'Numero total de Atendidos'],
                    tbody: [],
                },
                {
                    id: 5,
                    label: 'C2',
                    thead: ['Sexo', 'Grupo etario', 'CIE 10', 'Total atendido'],
                    tbody: [],
                },
                {
                    id: 6,
                    label: 'D1',
                    thead: ['Codigo especialidad', 'Ingresos', 'Egresos', 'Estancias', 'Pacientes dias', 'N° de camas', 'Dias cama disponible', 'Fallecidos'],
                    tbody: [],
                },
                {
                    id: 7,
                    label: 'D2',
                    thead: ['Sexo', 'Grupo etario', 'CIE 10', 'Total atendido'],
                    tbody: [],
                },
                {
                    id: 8,
                    label: 'E0',
                    thead: ['Tipo de parto', 'Complicacion del parto', 'Partos', 'Total de nacimientos', 'Nacimientos vivos', 'Nac. muertos'],
                    tbody: [],
                },
                {
                    id: 9,
                    label: 'F0',
                    thead: ['Sexo', 'Grupo de edad', 'Eventos', 'Total'],
                    tbody: [],
                },
                {
                    id: 10,
                    label: 'G0',
                    thead: ['Codigo de procedimiento', 'Total procedimientos', 'Servicio/especialiadad'],
                    tbody: [],
                },
                {
                    id: 11,
                    label: 'H0',
                    thead: ['Programacion', 'Cirugias mayores', 'Cirugias menores', 'Horas programadas', 'Horas efectivas', 'Hora acto quirurgico', 'Cirugias suspendidas'],
                    tbody: [],
                },
                {
                    id: 12,
                    label: 'I0',
                    thead: ['Centro asistencial', 'Correlativos otorgado', 'Número de HC', 'Tipo de documento', 'Número de documento', 'Sexo del paciento', 'Edad del Paciente','Servicio asistencial Origen','Centro Asistencial Origen','Servicio Asistencial Destino','Diagnostico Principal','Tipo de diagnostico','Diagnostico Secundaria','Tipo de diagnostico','Fecha de extension','Fecha de trámite o solicitud de referencia'],
                    tbody: [],
                },
                {
                    id: 13,
                    label: 'J0',
                    thead: [],
                    tbody: [],
                },
            ],
            filter: {
                table: 1,
                mounth: "",

            },
            period: "",
            ipress: "",
            dataShow: [],
            excel: [],
            //Pag
            page: 0,
            selectPage: 1,
            stepPagination: [],
            totalPagesToShow: 4,
        };
    },
    watch: {
        selectPage() {
            this.calculateData(10);
        },
    },
    computed: {
        cpData() {
            return this.dataShow;
        },
        cpClass() {
            return 'text-white border-white text-center bg-main text-xs';
        },
        limitedStepPagination() {
            const totalPages = this.stepPagination.length;
            const currentPage = this.selectPage;

            let startPage = 1;
            let endPage = totalPages;
            if (totalPages > this.totalPagesToShow) {
                const halfPagesToShow = Math.floor(this.totalPagesToShow / 2);

                if (currentPage > halfPagesToShow) {
                    startPage = currentPage - halfPagesToShow;
                    endPage = currentPage + halfPagesToShow - 1;

                    if (endPage > totalPages) {
                        endPage = totalPages;
                        startPage = totalPages - this.totalPagesToShow + 1;
                    }
                } else {
                    endPage = this.totalPagesToShow;
                }
            }

            return Array.from({
                    length: endPage - startPage + 1,
                },
                (_, i) => startPage + i
            );
        },

    },
    created() {
        this.getMonth();

    },
    methods: {
        ...mapActions(["get", "post"]),
        getMonth: function () {
            const currentDate = new Date();
            const month = currentDate.getMonth() + 1;
            this.filter.mounth = month;
            this.mtdGetData();
        },
        //Traer Data
        mtdGetData: function () {
            this.get({
                    url: this.$store.getters.get__url + "/control/tramas/" + this.filter.mounth,
                    token: this.$store.getters.get__token,
                })
                .then((response) => {
                    if (response.statusCode == 200) {

                        this.data = response.data;
                        this.period = this.data.period;
                        this.ipress = this.data.codeIpress;
                        this.tables[0].tbody = this.data.tablaA;
                        this.tables[1].tbody = this.data.tablaBuno;
                        this.tables[2].tbody = this.data.tablaBdos;
                        this.tables[3].tbody = this.data.tablaCuno;
                        this.tables[4].tbody = this.data.tablaCdos;
                        this.tables[5].tbody = this.data.tablaDuno;
                        this.tables[6].tbody = this.data.tablaDdos;
                        this.tables[7].tbody = this.data.tablaEuno;
                        this.tables[8].tbody = this.data.tablaF;
                        this.tables[9].tbody = this.data.tablaG;
                        this.tables[10].tbody = this.data.tablaH;
                        this.tables[11].tbody = this.data.tablaI;
                        this.tables[12].tbody = this.data.tablaJ;
                    }
                })
                .catch((errors) => {
                    this.$refs.SweetAlert.showError(errors);
                });
        },
        changeTable(id, index) {
            this.filter.table = id;
            this.pos = index;
        },
        //mapear las columnas:
        getColumnsByPos(pos, item) {
            const columnsByPos = {
                /* A */
                0: [item.room, item.room_func, item.beds_hosp, item.doctors, item.doctor_serum, item.doctor_residentes, item.nurses, item.dentist, item.psychologist, item.nutricionista, item.medical_tech, item.obstetrices, item.pharmacy, item.technical, item.other, item.ambulance],
                /* B1 */
                1: [item.sex_patient, item.group_age, item.total, 0, item.total],
                /* B2 */
                2: [item.sex_patient, item.group_age, item.code, item.total],
                /* C1 */
                3: [item.sex_patient, item.group_age, item.total, item.total],
                /* C2 */
                4: [item.sex_patient, item.group_age, item.code, item.total],
                /* D1 */
                5: [item.codigo, item.income, item.expense, item.estancias, item.patient_day, item.num_beds, item.days_beds, item.deaths],
                /* D2 */
                6: [item.sex_patient, item.group_age, item.code, item.total],
                /* E1 */
                8: [item.sex_type, item.group_age, item.evento, item.total],
                /* I */
                11: [item.origen, item.correlativo,item.hc, item.type_document, item.document, item.sex, item.age, item.service_origin],
            };
            return columnsByPos[pos] || [];
        },
        mtdExporTxt: function () {
            let array = this.tables[this.pos].tbody;
            this.excel = [];
            array.forEach(element => {
                let text = this.period + "|" + this.ipress + "|" + this.ipress + "|";
                let dataExport = this.getColumnsByPos(this.pos, element);
                // Añadir los valores al texto, separados por "|"
                text += dataExport.join("|");
                this.excel.push(text);
            });

            // Unir el array de strings con saltos de línea
            const textData = this.excel.join("\n");

            const blob = new Blob([textData], {
                type: "text/plain"
            });
            const link = document.createElement("a");
            link.href = URL.createObjectURL(blob);
            link.download = "tabla_" + this.tables[this.pos].label + ".txt";
            link.click();
            URL.revokeObjectURL(link.href);
        },
        exportExcel: function () {
            const datos = this.excel;
            const fileName = 'PLANILLAS';
            const typeExport = exportFromJson.types.xls;
            exportFromJson({
                data: datos,
                fileName: fileName,
                exportType: typeExport,
            });
        },
        calculateData(items) {
            if (!this.data || !this.data.length) {
                return (this.dataShow = []);
            }
            let filteredData = this.data;
            let indexInitial = this.selectPage;
            if (this.search.length >= 2 && this.search != "") {
                let query = this.search.toString().toUpperCase();
                filteredData = this.data.filter((element) => {
                    let name = element.patient.name.toString().toUpperCase();
                    let dni = element.patient.document.toString().toUpperCase();
                    return name.includes(query) || dni.includes(query);
                });
                indexInitial = 1;
            }
            let totalPages = Math.ceil(filteredData.length / items);
            this.stepPagination = Array.from({
                    length: totalPages,
                },
                (_, index) => index + 1
            );

            let startIndex = (indexInitial - 1) * items;
            let endIndex = startIndex + (items - 1);
            this.dataShow = filteredData.slice(startIndex, endIndex + 1);
        },

        //Paginacion
        backPage() {
            this.selectPage = this.selectPage > 1 ? this.selectPage - 1 : 1;
        },
        nextPage() {
            this.selectPage =
                this.selectPage < this.stepPagination.length ?
                this.selectPage + 1 :
                this.stepPagination.length;
        },
        selectedPage(page) {
            this.selectPage = page;
        },
        mtdNumber: function (index) {
            return (this.selectPage - 1) * 10 + (index + 1)
        },
        returnHome: function () {
            this.$emit("mtdChangePage", 'home');
        },
        getMonthName: function (monthString) {
            const months = [
                'Enero', 'Febrero', 'Marzo', 'Abril', 'Mayo', 'Junio',
                'Julio', 'Agosto', 'Septiembre', 'Octubre', 'Noviembre', 'Diciembre'
            ];
            const monthNumber = parseInt(monthString, 10);
            if (!isNaN(monthNumber) && monthNumber >= 1 && monthNumber <= 12) {
                return months[monthNumber - 1];
            } else {
                return 'Mes no válido';
            }
        },
        mes: function (mes) {
            let monthName = this.getMonthName(mes);
            return monthName;
        }
    },
    filters: {
        formatDate(date) {
            return date != null ? moment(date).format("DD/MM/YYYY") : "-";
        },
        formatTime(time) {
            let arTime = time.split(":");
            if (arTime[0] <= 12) {
                return time + " am";
            } else {
                return arTime[0] - 12 + ":" + arTime[1] + ":" + arTime[2] + " pm";
            }
        },
    },
}
</script>
